import { Component, OnInit } from '@angular/core';
import { NgForm,FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {

  forgotRequest: any= {};
  forgotError: any;
  forgotSuccess: any;

  constructor( public authService: AuthService,) { }

  ngOnInit() {
  }

  doForgot(form: NgForm) {
    
    if (form.valid) {
      let request:any = {
       
      };
      request = Object.assign({}, this.forgotRequest);

      this.authService.forgotpassword(request).then(async (_res) => {
        console.log(_res);
            if (_res.status == 0) {
              this.forgotError = _res.message;
            } else {
              this.forgotSuccess = _res.message;
            }
            
             }).catch((err) => {
              this.forgotError =  err;
        });
      }    
  }

}
